import serialize from 'serialize-javascript';

const storeHoursMock = {
  monday: { open: '6:00', close: '21:00' },
  tuesday: { open: '6:00', close: '21:00' },
  wednesday: { open: '6:00', close: '21:00' },
  thursday: { open: '6:00', close: '21:00' },
  friday: { open: '6:00', close: '21:00' },
  saturday: { open: '6:00', close: '21:00' },
  sunday: { open: '8:00', close: '20:00' }
};

export const ContextBuilder = {
  server({ expConfiguration = {}, requestData = {}, hosts = {} }) {
    const experienceContext = {
      channel: requestData.channel || 'desktop',
      cookie: {
        adobeCookie: requestData.adobeCookie
      },
      configService: {
        searchStream: expConfiguration?.['search.stream'],
        searchStreamLimit: expConfiguration?.['search.streamLimit'],
        dynamicBotRendering: expConfiguration?.['fs-dynamic-bot-rendering']
      },
      hosts,
      path: (requestData.route && requestData.route.path) || '/',
      store: {
        storeHours: requestData.storeHours || storeHoursMock,
        storeId: requestData.storeId || '121',
        storeName: requestData.storeName || 'Cumberland',
        storeZip: requestData.localStoreZip || '30339'
      },
      segment: requestData.segment,
      isDebugMode: requestData.isDebugMode,
      isAkamaiBot: !!requestData.akamaiBotDetection,
      customer: requestData.customer,
      localStoreZip: requestData.localStoreZip,
      deliveryZip: requestData.deliveryZip
    };
    return {
      contextScript: `
      <script>window.__EXPERIENCE_CONTEXT__ =
      {
        "cookie": ${serialize(experienceContext.cookie)},
        "channel": ${serialize(experienceContext.channel)},
        "configService": ${serialize(experienceContext.configService)},
        "hosts": ${serialize(experienceContext.hosts)},
        "path": ${serialize(experienceContext.path)},
        "store": ${serialize(experienceContext.store)},
        "segment": ${serialize(experienceContext.segment)},
        "isDebugMode": ${serialize(experienceContext.isDebugMode)},
        "isAkamaiBot": ${serialize(experienceContext.isAkamaiBot)},
        "customer": ${serialize(experienceContext.customer)},
        "localStoreZip": ${serialize(experienceContext.localStoreZip)},
        "deliveryZip": ${serialize(experienceContext.deliveryZip)}
      }
      </script>
      `,
      experienceContext
    };
  },
  client() {
    const experienceContext = {
      cookie: (window.__EXPERIENCE_CONTEXT__ && window.__EXPERIENCE_CONTEXT__.cookie) || {},
      channel: window.__EXPERIENCE_CONTEXT__ && window.__EXPERIENCE_CONTEXT__.channel,
      configService: (window.__EXPERIENCE_CONTEXT__ && window.__EXPERIENCE_CONTEXT__.configService) || {},
      hosts: (window.__EXPERIENCE_CONTEXT__ && window.__EXPERIENCE_CONTEXT__.hosts) || {},
      path: window.__EXPERIENCE_CONTEXT__ && window.__EXPERIENCE_CONTEXT__.path,
      store: (window.__EXPERIENCE_CONTEXT__ && window.__EXPERIENCE_CONTEXT__.store) || {},
      segment: (window.__EXPERIENCE_CONTEXT__ && window.__EXPERIENCE_CONTEXT__.segment) || '',
      isDebugMode: (window.__EXPERIENCE_CONTEXT__ && typeof window.__EXPERIENCE_CONTEXT__.isDebugMode !== 'undefined')
        ? window.__EXPERIENCE_CONTEXT__.isDebugMode
        : false,
      isAkamaiBot: (window.__EXPERIENCE_CONTEXT__ && typeof window.__EXPERIENCE_CONTEXT__.isAkamaiBot !== 'undefined')
        ? window.__EXPERIENCE_CONTEXT__.isAkamaiBot
        : false,
      customer: (window.__EXPERIENCE_CONTEXT__ && window.__EXPERIENCE_CONTEXT__.customer) || {},
      localStoreZip: (window.__EXPERIENCE_CONTEXT__ && window.__EXPERIENCE_CONTEXT__.localStoreZip) || '',
      deliveryZip: (window.__EXPERIENCE_CONTEXT__ && window.__EXPERIENCE_CONTEXT__.deliveryZip) || ''
    };
    return {
      experienceContext
    };
  },
};
